import React, { Component } from 'react';

const REASONS = [
    { id: 'completed', label: 'Completed' },
    { id: 'settled', label: 'Settled' },
    { id: 'withdrawn', label: 'Withdrawn' },
    { id: 'not_relevant', label: 'No longer relevant' }
];

export default class ArchiveModal extends Component {
    constructor(props) {
        super(props);
        this.state = { reason: 'completed', submitting: false };
    }

    handleConfirm = async () => {
        this.setState({ submitting: true });
        try {
            await this.props.onConfirm(this.state.reason);
        } finally {
            this.setState({ submitting: false });
        }
    };

    render() {
        if (!this.props.open) return null;
        const { applicationName, onClose } = this.props;
        return (
            <div
                className="fixed inset-0 z-50 flex items-center justify-center"
                style={{ backgroundColor: 'rgba(15, 23, 42, 0.55)' }}
                onClick={onClose}
            >
                <div
                    className="w-full max-w-md rounded-lg p-6 shadow-xl"
                    style={{ backgroundColor: '#FFFFFF' }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <h3 className="text-lg font-bold mb-1" style={{ color: '#0F172A' }}>Archive application</h3>
                    <p className="text-sm mb-4" style={{ color: '#64748B' }}>
                        {applicationName ? `Archive "${applicationName}"?` : 'Archive this application?'} It will be hidden from the active list and shown under previous applications.
                    </p>
                    <div className="space-y-2 mb-5">
                        {REASONS.map((r) => (
                            <label
                                key={r.id}
                                className="flex items-center gap-2 cursor-pointer rounded-md px-3 py-2"
                                style={{
                                    backgroundColor: this.state.reason === r.id ? '#EFF6FF' : '#F8FAFC',
                                    border: `1px solid ${this.state.reason === r.id ? '#3B82F6' : '#E2E8F0'}`
                                }}
                            >
                                <input
                                    type="radio"
                                    name="archive_reason"
                                    value={r.id}
                                    checked={this.state.reason === r.id}
                                    onChange={() => this.setState({ reason: r.id })}
                                />
                                <span className="text-sm font-medium" style={{ color: '#0F172A' }}>{r.label}</span>
                            </label>
                        ))}
                    </div>
                    <div className="flex justify-end gap-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 rounded-md text-sm font-semibold"
                            style={{ backgroundColor: '#E5E7EB', color: '#1F2937' }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={this.handleConfirm}
                            disabled={this.state.submitting}
                            className="px-4 py-2 rounded-md text-sm font-semibold"
                            style={{
                                backgroundColor: this.state.submitting ? '#94A3B8' : '#DC2626',
                                color: '#FFFFFF',
                                cursor: this.state.submitting ? 'wait' : 'pointer'
                            }}
                        >
                            {this.state.submitting ? 'Archiving…' : 'Archive'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
